export const SIZES = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'large',
};

export const ALIGN = {
  left: 'left',
  right: 'right',
  center: 'center',
};

export const TYPES = {
  text: 'text',
  password: 'password',
};
